module.exports = __webpack_public_path__ + "img/xls.3d2b63f.svg";